<template>
    <div class='view-product-container'>
        <div class='header'>
            <!-- <div>{{product.product}}</div> -->
            <div class='cross-icon' @click='returnToRecommendedProducts'><i class="fa-solid fa-xmark"></i></div>
        </div>
        <div>
            <ProductImagesOnPopout :product='product' :product_code_changed_watcher='product_code_changed_watcher'/>
        </div>
        <div>
            <ProductInfo :product='product' :stock='stock' :average_rating='average_rating' :total_reviews='total_reviews' :product_code_changed_watcher='product_code_changed_watcher' @updatedCartListener='updatedCartListener' :redirect_on_click='false' @colourClickedListener='colourClicked' :product_on_popout='true'/>
        </div>
         <div class='reviews-container' id='product_popout_reviews_container'>
            <Reviews @reviewsListener='reviewsData' :product_id='product_code' :product_code_changed_watcher='product_code_changed_watcher' :product_on_popout='true'/>
        </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";

import Product from '@/ecom/views/pages/Product.vue';
import ProductInfo from '@/ecom/components/products/single_product/details/ProductInfo.vue';
import ProductImagesOnPopout from '@/ecom/components/navigation/header/basket/ProductImagesOnPopout.vue';
import Reviews from '@/ecom/components/products/single_product/reviews/Reviews.vue';

export default {
    components: {Product, ProductInfo, ProductImagesOnPopout, Reviews},
    props: ['product_code', 'product_code_changed_watcher'],
    emits: ['returnToRecommendedProductsListener', 'updatedCartListener', 'colourClickedListener'],
    data(){
        return{
            product: {},
            stock: {},
            total_reviews: 0,
            average_rating: 0
        }
    },
    methods:{
        async getProduct(){
            let response = await fetch(`/api/product?product_code=${this.product_code}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.product = results.product;
                this.stock = results.stock;
            }
        },
        returnToRecommendedProducts(){
            this.$emit('returnToRecommendedProductsListener')
        },
        updatedCartListener(){
            this.$emit('updatedCartListener');
        },
        colourClicked(product_code, url){
            this.$emit('colourClickedListener', product_code, url);
        },
        reviewsData(total_reviews, average_rating){
            this.total_reviews = total_reviews;
            this.average_rating = average_rating;
        }
    },
    watch:{
        'product_code_changed_watcher': function(){
            this.product = {};
            this.stock = {};
            this.getProduct();
        }
    }
}
</script>

<style lang="scss" scoped>
.view-product-container{
    container-type: inline-size;
    padding: 20px;
    margin-bottom: 200px;
}

.header{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 1.2rem;
}

.cross-icon{
    cursor: pointer;
}

.reviews-container{
    margin-top: 20px;
}
</style>